import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const schedulingListDataShared: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fscheduling%2Fscheduling-seo-image.png?alt=media&token=ff6cbba4-89cb-4d6f-b047-f934975cd12d",
  title: "Advanced Scheduling",
  subtitle: "Set it up & Let it Run",
  page: WildNavigationType.SCHEDULINGBOOKINGENGINE,
}